module.exports = __webpack_public_path__ + "static/scale-model-of-gita-lungo-i-canali-in-chicago-illinois-55b34866ce100b2af075a6d236f547bd.png";